export const FETCH_LAMB_BODIES_REQUEST = "FETCH_LAMB_BODIES_REQUEST";
export const FETCH_LAMB_BODIES_SUCCESS = "FETCH_LAMB_BODIES_SUCCESS";
export const FETCH_LAMB_BODIES_FAILURE = "FETCH_LAMB_BODIES_FAILURE";
export const CREATE_LAMB_BODY_REQUEST = "CREATE_LAMB_BODY_REQUEST";
export const CREATE_LAMB_BODY_SUCCESS = "CREATE_LAMB_BODY_SUCCESS";
export const CREATE_LAMB_BODY_FAILURE = "CREATE_LAMB_BODY_FAILURE";

export const fetchLambBodiesRequest = () => ({
  type: FETCH_LAMB_BODIES_REQUEST,
});

export const fetchLambBodiesSuccess = (lambBody) => ({
  type: FETCH_LAMB_BODIES_SUCCESS,
  payload: lambBody,
});
export const fetchLambBodiesFailure = (error) => ({
  type: FETCH_LAMB_BODIES_FAILURE,
  payload: error,
});

export const createLambBodyRequest = () => ({
  type: CREATE_LAMB_BODY_REQUEST,
});

export const createLambBodySuccess = (createdLambBodies) => ({
  type: CREATE_LAMB_BODY_SUCCESS,
  payload: createdLambBodies,
});

export const createLambBodyFailure = (error) => ({
  type: CREATE_LAMB_BODY_FAILURE,
  payload: error,
});
